import { NavLink } from "react-router-dom";
import { BarChart3, Building2, TrendingUp } from "lucide-react";
import { useUser } from "../../context/UserContext";

// Onglets « Pilotage des évals nationales » du chef (vues sans idclasse). Même
// habillage que PilotageCoordoTabs. AUTO-MASQUÉ hors chef. Cohabite avec
// PilotageCoordoTabs sur la route partagée eval-nat-niveau : chacune est gatée par
// rôle (un utilisateur est soit professeur soit chef), donc une seule s'affiche.
function PilotageNatChefTabs() {
    const { user } = useUser();
    if (user?.role !== "chef") return null;

    const onglets = [
        { label: "Résultats des évaluations", to: "/home/eval-nat-niveau/", icone: BarChart3 },
        { label: "École secteur", to: "/home/ecoles/", icone: Building2 },
        { label: "Évolution des résultats", to: "/home/evolution/", icone: TrendingUp },
    ];

    return (
        <div className="px-4 pt-4">
            <div className="inline-flex flex-wrap gap-1 bg-white rounded-xl border border-slate-200 shadow-sm p-1">
                {onglets.map(({ label, to, icone: Icone }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[13px] font-medium transition-colors duration-200 ${
                                isActive
                                    ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md shadow-blue-500/30'
                                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                            }`
                        }
                    >
                        <Icone className="w-4 h-4" />
                        {label}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}

export default PilotageNatChefTabs;
